// extracted by mini-css-extract-plugin
module.exports = {"predicate":"D5OYTCJrASRA0Kml6Vxy"};